import { mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";

export default {
    name: "Header",

    data() {
        return {
            resumeCount: null,
            isOpen: false,
        };
    },

    computed: {
        ...mapGetters({ isApplicantLoggedIn: "isApplicantLoggedIn", applicantId: "applicantId", applicantToken: "applicantToken", resumeCountNo: "resumeCountNo" })
    },

    watch: {
        $route() {
            this.isOpen = false;
        }
    },

    methods: {
        logoutApplicant() {
            store.dispatch("applicantLogout")
            .then(() => {
                this.$router.push({ name: "applicantLogin" });
            })
            .catch((error) => {
                console.log(error);
                this.$router.push({ name: "applicantLogin" });
            });
        },

        getResumeCount() {
            axios.get("/applicant/resume/count/" + this.applicantId)
                .then(response => {
                    this.resumeCount = response.data.count;
                    store.commit("setResumeCount", this.resumeCount);
                })
                .catch(error => {
                    console.log("Resume Count API error:::::>", error.response.data);
                });
        },

        goResumeRegister() {
            this.isOpen = false;
            if (!this.isApplicantLoggedIn) {
                this.$router.push({ name: 'applicantLogin', query: { reason: 'cv' } }, () => {});
                return;
            }
            if (this.resumeCountNo < 3) {
                this.$router.push('/resume', () => {});
            } else {
                this.$notification.error("အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။", { timer: 3 , position: 'bottomCenter'});
            }
        },

        goJobRequestCreate() {
            this.isOpen = false;
            if (!this.isApplicantLoggedIn) {
                this.$router.push({ name: 'applicantLogin', query: { reason: 'post' } }, () => {});
                return;
            }
            this.$router.push({
                name: 'jobRequestCreate',
                params: { id: this.applicantId },
            }, () => {});
        },
        
        toggle: function(){
            this.isOpen = !this.isOpen
        },

        handleResize() {
            if (window.innerWidth > 1040) {
                this.isOpen = false;
            }
        }
    },

    mounted() {
        if (this.applicantId) {   
            this.getResumeCount();
        }
        window.addEventListener("resize", this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
};